import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import {Md5} from 'ts-md5';

import {AppService} from '@api';
import {SistemaService} from '@servicios/Sistema.Service';
import {UsuarioService} from '@servicios/Usuario.service';

import {MensajeService} from '@mensaje/Mensaje.Service';
import {AlertaEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';

@Component(
    {
        selector: 'cambiarPassword',
        templateUrl: './CambiarPassword.template.html',
        styleUrls: ['./CambiarPassword.scss'],
    })

export class CambiarPasswordComponent {
    public datos: any;
    public errorActivo: boolean;
    public reiniciarPassword: boolean;

    public verPasswordActual: boolean = false;
    public verPasswordNueva: boolean = false;
    public verPasswordRepetido: boolean = false;

    constructor(private appService: AppService, private usuarioService: UsuarioService, private mensajeService: MensajeService, private router: Router, public sistemaService: SistemaService, private location: Location, public translate: TranslateService) {
        this.datos = {Actual: "", Nuevo: "", Repetir: ""};
        this.errorActivo = false;
        this.reiniciarPassword = this.sistemaService.usuario.reiniciarcontrasena;
    }

    ngOnInit() {
    }

    CambairPassword() {
        this.errorActivo = true;

        if (!this.ValidarPassword()) {
            this.mensajeService.Alerta(AlertaEnum.Warning, this.translate.instant("ErrorDatosIncompletos"));
            return;
        }

        this.appService.Put("auth/cambiarpassword", {Actual: Md5.hashStr(this.datos.Actual), Nuevo: Md5.hashStr(this.datos.Nuevo), Repetir: Md5.hashStr(this.datos.Repetir)}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.mensajeService.Alerta(AlertaEnum.Success, res.message);

                if (this.reiniciarPassword) {
                    this.sistemaService.usuario.reiniciarcontrasena = false;
                    this.router.navigateByUrl("/app/home");
                }
                else {
                    this.location.back();
                }
            }
        })
    }

    ValidarPassword(): boolean {
        if (!this.datos.Nuevo || !this.datos.Repetir || !this.datos.Actual) {
            return false;
        }

        if (this.datos.Nuevo != this.datos.Repetir) {
            return false;
        }

        if (!this.datos.Nuevo.match(this.sistemaService.usuario.expresionpassword)) {
            return false;
        }

        return true;
    }

    Cancelar() {
        if (this.reiniciarPassword) {
            this.usuarioService.CerrarSesion();
        }
        else {
            this.location.back();
        }
    }
}
